/*
 * @Author: COCO
 * @Date: 2018-06-26 09:34:09
 * @Last Modified by: COCO
 * @Last Modified time: 2019-03-05 11:10:33
 * 所有请求客户端接口
 */
import request from './request';
const APPID = '5b51d9e86bfb7';
const baseUrl = `//xfer.${window.Acme.getDomain()}`;

class hotSpotAnalysis {
  //获取板块下面的个股接口
  getPlateStockCodeList(platecode) {
    return request.get(
      `${baseUrl}/webrpc?appid=${APPID}&method=send&params=[{%22platecode%22:${platecode},%22@reqtype%22:%22/stock/plate/queryplatestocks%22}]&router=api/b2cweb/servicestock`
    );
  }
  //获取所有板块的二级和三级板块
  getSubPlateList(platecode) {
    return request.get(
      `${baseUrl}/webrpc?appid=${APPID}&method=send&params=[{%22platecode%22:${platecode},%22@reqtype%22:%22/stock/plate/queryplatelink%22}]&router=api/b2cweb/servicestock`
    );
  }

  //获取基础行情数据
  /**
   *
   * stock 股票代码 [300033,002497]
   * formulaid 行情数据项ID [19,1015]
   * period 周期 16384
   * startdate 开始时间 20180710
   * endate 结束时间 20180731
   */
  getBaseHqData({ stock, formulaid, period, startdate, enddate }) {
    startdate = startdate || '';
    enddate = enddate || '';
    return request.get(
      `${baseUrl}/webrpc?appid=${APPID}&method=getDatas
      &params=[{"stock":[${stock}],"formulaid":[${formulaid}],"startdate":"${startdate}","enddate":"${enddate}","period":${period}}]&router=/api/quote/formulacache`
    );
    // return request.post(
    //   `//xfer.10jqka.com.cn/webrpc?appid=${APPID}&method=getDatas&router=/api/quote/formulacache&cocotest=1`,
    //   {
    //     params: [{ stock: [stock], formulaid: [formulaid], startdate: startdate, enddate: enddate, period: period }]
    //   }
    // );
    // return request({
    //   url: `//xfer.10jqka.com.cn/webrpc?appid=${APPID}&method=getDatas&router=/api/quote/formulacache&cocotest=1`,
    //   headers: {
    //     'Content-type': 'application/x-www-form-urlencoded'
    //   },
    //   method: 'post',
    //   data: {
    //     params: JSON.stringify([
    //       { stock: stock, formulaid: formulaid, startdate: startdate, enddate: enddate, period: period }
    //     ])
    //   },
    //   transformRequest: [
    //     function(data) {
    //       let ret = '';
    //       for (let it in data) {
    //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]);
    //       }
    //       return ret;
    //     }
    //   ]
    // });
  }
}

export default new hotSpotAnalysis();



// WEBPACK FOOTER //
// ./src/api/hotSpotAnalysis.js